export class ParamParser {
  static parseParams(params: URLSearchParams): any {
    const result: any = {};
    
    params.forEach((value, key) => {
      result[key] = this.parseValue(value);
    });
    
    return result;
  }

  static parseValue(value: string): any {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (!isNaN(Number(value))) return Number(value);
    return value;
  }

  static getParam(params: any, key: string, defaultValue: any): any {
    const value = params[key];
    return value !== undefined ? value : defaultValue;
  }

  static applyPreset(params: any, preset: string): void {
    const presets: { [key: string]: any } = {
      'bouncing': { gravity: 0.1, minSpeed: 1, maxSpeed: 2, collision: false },
      'floating': { gravity: 0, minSpeed: 1.2, maxSpeed: 1.4, collision: true },
      'walking': { gravity: 0.9, minSpeed: 0.3, maxSpeed: 0.6, collision: false },
      'standing': { gravity: 0.1, minSpeed: 0, maxSpeed: 0, collision: false },
      'passing': { gravity: 0.1, minSpeed: 1, maxSpeed: 1, collision: false }
    };

    if (preset && presets[preset]) {
      Object.assign(params, presets[preset]);
    }
  }
}